<i [class]="classes()" [style]="styles()"></i>
